import { render, staticRenderFns } from "./ExerciseEditDialog.vue?vue&type=template&id=23e0bdaf&scoped=true&"
import script from "./ExerciseEditDialog.vue?vue&type=script&lang=js&"
export * from "./ExerciseEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseEditDialog.vue?vue&type=style&index=0&id=23e0bdaf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e0bdaf",
  null
  
)

export default component.exports